<div class="records-shell">
  <header class="records-header">
    <div>
      <h1>Collected Service Records</h1>
      <p>Review every submission captured through the briefing form.</p>
    </div>
    <div class="records-header__actions">
      <button type="button" class="button button--secondary" routerLink="/">
        Back to Home
      </button>
    </div>
  </header>

  <nav class="breadcrumb">
    <a routerLink="/">Home</a>
    <span class="breadcrumb__separator">�</span>
    <span>Collected Records</span>
  </nav>

  <section class="records-status">
    <span class="status status--info" *ngIf="loading()">
      <span class="spinner__dot"></span>
      <span>Loading collected records...</span>
    </span>
    <span class="status status--success" *ngIf="!loading() && statusMessage()">
      {{ statusMessage() }}
    </span>
    <span class="status status--error" *ngIf="errorMessage()">
      {{ errorMessage() }}
    </span>
  </section>

  <section class="records-table-wrapper" *ngIf="records().length && !loading(); else emptyState">
    <table class="records-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Type</th>
          <th>Business Type</th>
          <th>Location</th>
          <th>Description</th>
          <th class="records-table__actions-heading">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of records()">
          <td>{{ record.id }}</td>
          <td>{{ record.name }}</td>
          <td>{{ record.type | titlecase }}</td>
          <td>{{ record.business_type }}</td>
          <td>{{ record.location || 'N/A' }}</td>
          <td>{{ record.description }}</td>
          <td class="records-table__actions">
            <a
              class="button button--accent button--small"
              [routerLink]="['/audiences', record.id]"
            >
              View Target Audience Profile
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </section>

  <ng-template #emptyState>
    <p class="records-empty">
      No records have been submitted yet. Complete the form on the Home page to add your first entry.
    </p>
  </ng-template>
</div>
